import { Field, inputCls } from "./Field";

const NUM = [
  ["monthly_fee", "Standard monthly fee"],
  ["min_classes", "Min. classes per month"],
  ["full_threshold", "Full fee from (classes attended)"],
  ["reduced_fee", "Reduced fee (below threshold)"],
  ["sibling_discount", "Sibling discount on total"],
  ["free_trial", "Free trial classes"],
];

const CONTACT = [
  ["phone", "Phone (display)"],
  ["whatsapp", "WhatsApp number (digits, with country code)"],
  ["instagram", "Instagram URL"],
  ["location", "Location"],
  ["map_url", "Google Maps link"],
  ["trial_message", "WhatsApp pre-filled message"],
  ["location_ar", "Location (Arabic)"],
  ["trial_message_ar", "WhatsApp message (Arabic)"],
];

export const PricingEditor = ({ pricing, onChange }) => (
  <div className="grid gap-4 rounded-2xl border border-white/10 bg-[#12121A] p-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="admin-pricing-editor">
    <Field label="Currency"><input className={inputCls} value={pricing.currency} onChange={(e) => onChange({ ...pricing, currency: e.target.value })} data-testid="admin-pricing-currency" /></Field>
    {NUM.map(([k, label]) => (
      <Field key={k} label={label}>
        <input type="number" min="0" step="any" className={inputCls} value={pricing[k]} data-testid={`admin-pricing-${k}`}
          onChange={(e) => onChange({ ...pricing, [k]: e.target.value === "" ? 0 : Number(e.target.value) })} />
      </Field>
    ))}
    <Field label="Free trial note" className="sm:col-span-2"><input className={inputCls} value={pricing.note} onChange={(e) => onChange({ ...pricing, note: e.target.value })} data-testid="admin-pricing-note" /></Field>
    <Field label="Currency (Arabic)"><input dir="rtl" className={`${inputCls} font-arabic`} value={pricing.currency_ar || ""} onChange={(e) => onChange({ ...pricing, currency_ar: e.target.value })} data-testid="admin-pricing-currency_ar" /></Field>
    <Field label="Free trial note (Arabic)" className="sm:col-span-2"><input dir="rtl" className={`${inputCls} font-arabic`} value={pricing.note_ar || ""} onChange={(e) => onChange({ ...pricing, note_ar: e.target.value })} data-testid="admin-pricing-note_ar" /></Field>
  </div>
);

export const ContactEditor = ({ contact, onChange }) => (
  <div className="grid gap-4 rounded-2xl border border-white/10 bg-[#12121A] p-5 sm:grid-cols-2" data-testid="admin-contact-editor">
    {CONTACT.map(([k, label]) => (
      <Field key={k} label={label}>
        <input dir={k.endsWith("_ar") ? "rtl" : "ltr"} className={`${inputCls} ${k.endsWith("_ar") ? "font-arabic" : ""}`} value={contact[k] || ""} onChange={(e) => onChange({ ...contact, [k]: e.target.value })} data-testid={`admin-contact-${k}`} />
      </Field>
    ))}
  </div>
);
